var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score"},[_c('div',{staticClass:"score__red"},[_vm._v(_vm._s(_vm.redScore)+"/"+_vm._s(_vm.redTotal)+" "+_vm._s(_vm.t("red")))]),_c('div',{staticClass:"score__blue"},[_vm._v(" "+_vm._s(_vm.t("blue"))+" "+_vm._s(_vm.blueScore)+"/"+_vm._s(_vm.blueTotal)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }